import { authRequestInterceptor } from './interceptors/request-interceptors';
import { PublicAPI, RestrictedAPI } from '../api/api';
import { responseInterceptor } from './interceptors/response-interceptors';

authRequestInterceptor(RestrictedAPI);
responseInterceptor(RestrictedAPI);

export { PublicAPI, RestrictedAPI };
